import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import GlobalContext from 'agency/digital_renderer/utils/context'
import KeyFeaturesWrapper from 'agency/digital_renderer/components/KeyFeaturesWrapper'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'

import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'
import ElementContainer from '../../ElementContainer'

const findContainer = items => items.find(item => item && item.item_type === 'container')

const renderFeatures = (container, features) => features.map((feature) => {
  const featureContext = {
    title: feature,
  }

  return (
    <div key={feature} style={deviceStyle(container)}>
      <ElementContainer
        forwardContextToItems={featureContext}
        section={container}
        renderNested
        render={({ itemComponents }) => itemComponents.map(component => component)}
      />
    </div>
  )
})

const KeyFeatures = (props) => {
  const { items, options } = props

  const featureContainer = findContainer(items) || {}
  const style = deviceStyle(props)

  const defaultContext = useContext(GlobalContext)
  const { campaign } = defaultContext

  return (
    <KeyFeaturesWrapper
      campaign={campaign}
      render={({ features }) => (
        <AnimationWrapper options={options}>
          <div style={style}>{renderFeatures(featureContainer, features)}</div>
        </AnimationWrapper>
      )}
    />
  )
}

KeyFeatures.propTypes = {
  items: PropTypes.array,
  options: PropTypes.object,
}

KeyFeatures.defaultProps = {
  items: [],
}

export default KeyFeatures
